import { render, staticRenderFns } from "./britannia-2b.vue?vue&type=template&id=d4e3fb62&"
import script from "./britannia-2b.vue?vue&type=script&lang=js&"
export * from "./britannia-2b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports